import type { Components, Theme } from '@mui/material';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  defaultProps: {
    PaperProps: { elevation: 0 },
  },
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.spacing(2),
      border: 'none',
      boxShadow: theme.shadows[5],
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(1),
      },
    }),
  },
  variants: [
    {
      props: { variant: 'right' },
      style: ({ theme }) => ({
        '& .MuiDialog-container': {
          justifyContent: 'flex-end',
        },
        '& .MuiDialog-paper': {
          margin: theme.spacing(2),
          maxWidth: 388,
          height: `calc(100% - ${theme.spacing(4)})`,
          maxHeight: `calc(100% - ${theme.spacing(4)})`,
          [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(1),
            height: `calc(100% - ${theme.spacing(2)})`,
            maxHeight: `calc(100% - ${theme.spacing(2)})`,
          },
        },
      }),
    },
    {
      props: { variant: 'right', size: 'wide' },
      style: {
        '& .MuiDialog-paper': {
          maxWidth: 600,
        },
      },
    },
  ],
};
